<script lang="ts">
	import { getEditor } from "luxedo-canvas"
	import { Responsive } from "responsive"
	import { MaskEditorController } from "./MaskEditorController"
	import { MaskBase } from "luxedo-canvas/asset"

	interface Props {
		showCanvas: boolean
		hasSelection: boolean
		isTransforming: boolean
	}

	let { showCanvas, hasSelection, isTransforming }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)
	let isHidden = $derived(isMobile && !showCanvas)

	function deselectAll() {
		if (getEditor().mode.get()) MaskEditorController.completeEdit()

		getEditor().selection.clear()
	}

	function transformMask() {
		const selectedMask = getEditor().selection.get()[0]
		MaskEditorController.editMask(selectedMask as MaskBase)
	}
</script>

<div id="canvas-wrapper" class:isHidden>
	<div id="canvas-container"></div>
</div>

{#if isMobile && hasSelection && !isTransforming}
	<div class="button-container">
		<button class="transform-button alt" onclick={transformMask}>Transform</button>
		<button class="deselect-button" onclick={deselectAll}>Done</button>
	</div>
{/if}

<style>
	#canvas-wrapper {
		position: relative;
		background-color: #f0f8ff00;
		height: 100%;
		flex-grow: 1;
	}

	#canvas-wrapper.isHidden {
		flex-shrink: 1;
		flex-grow: 0;
		height: unset;
	}

	#canvas-container {
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: var(--z-index-back);
	}

	.button-container {
		width: calc(100% - 1rem);
		margin: 0.5rem;
	}

	.button-container button {
		flex-basis: calc(50% - 0.5rem);
		text-align: center;
	}
</style>
